import {observer} from 'mobx-react';

const DimensionPTOCell = observer(({model, parent}) => {
  if (!model.dimensionless) return null;

  return (
    <div>{parent.ptoTotal}</div>
  );
});

export default DimensionPTOCell;
